import type { ReactNode } from 'react'
import { App as CapacitorApp } from '@capacitor/app'
import { BottomSheet } from './BottomSheet'
import { Button } from './Button'
import { usePushBackHandler } from '../../context/BackStackContext'

export interface ExitConfirmSheetProps {
  open: boolean
  onClose: () => void
  onExit?: () => void
  title?: string
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
}

export const ExitConfirmSheet = ({
  open,
  onClose,
  onExit = () => void CapacitorApp.exitApp(),
  title = 'Exit app?',
  description = 'Are you sure you want to close the app?',
  confirmLabel = 'Exit',
  cancelLabel = 'Stay',
}: ExitConfirmSheetProps) => {
  usePushBackHandler(onClose, open)

  return (
    <BottomSheet
      isOpen={open}
      onClose={onClose}
      title={title}
      className="memberBottomSheet exitConfirmSheet"
      maxHeightSvh={40}
    >
      <div className="p-4 flex flex-col gap-4 text-[var(--text-strong)]" data-testid="exit-confirm-sheet">
        <p className="text-sm text-[var(--muted)]">{description}</p>
        <div className="flex items-center justify-end gap-3 pt-2">
          <Button
            variant="tertiary"
            size="md"
            onClick={onClose}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="secondary"
            tone="danger"
            size="md"
            onClick={onExit}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </BottomSheet>
  )
}
